module.exports = __webpack_public_path__ + "img/av-desktop-hover.620067d7.png";